/* eslint-env browser */

import * as React from 'react'
import withTranslator from './TranslatorProvider'

const PropTypes = require('prop-types')
const classNames = require('classnames')

const Pagination = props => {
  const { page, perPage, totalCount, getUrl, onSelectPage, translate } = props

  const nbPages = Math.max(Math.ceil(totalCount / perPage), 1)

  return (
    <div className="container">
      <nav className="pagination is-centered" aria-label="pagination">
        <ul className={classNames('pagination-list', { hidden: totalCount === 0 })}>
          <li>
            <a
              href={page > 0 ? getUrl(page - 1) : undefined}
              onClick={e => {
                e.preventDefault()
                onSelectPage(page - 1)
                return false
              }}
              className="pagination-previous"
              disabled={page === 0}
            >
              {'<'}
            </a>
          </li>
          {page !== 0 && (
            <li>
              <a
                href={getUrl(1)}
                onClick={e => {
                  e.preventDefault()
                  onSelectPage(0)
                  return false
                }}
                className="pagination-link"
              >
                1
              </a>
            </li>
          )}
          {page > 2 && (
            <li>
              <span className="pagination-ellipsis">&hellip;</span>
            </li>
          )}
          {page !== 1 && page !== 0 && (
            <li>
              <a
                href={getUrl(page - 1)}
                onClick={e => {
                  e.preventDefault()
                  onSelectPage(page - 1)
                  return false
                }}
                className="pagination-link"
              >
                {page}
              </a>
            </li>
          )}
          <li>
            <a
              href={getUrl(page)}
              onClick={e => {
                e.preventDefault()
                onSelectPage(page)
                return false
              }}
              className="pagination-link is-current"
            >
              {page + 1}
            </a>
          </li>
          {page < nbPages - 2 && (
            <li>
              <a
                href={getUrl(page + 1)}
                onClick={e => {
                  e.preventDefault()
                  onSelectPage(page + 1)
                  return false
                }}
                className="pagination-link"
              >
                {page + 2}
              </a>
            </li>
          )}
          {nbPages - page > 3 && (
            <li>
              <span className="pagination-ellipsis">&hellip;</span>
            </li>
          )}
          {page !== nbPages - 1 && (
            <li>
              <a
                href={getUrl(nbPages)}
                onClick={e => {
                  e.preventDefault()
                  onSelectPage(nbPages - 1)
                  return false
                }}
                className="pagination-link"
              >
                {nbPages}
              </a>
            </li>
          )}
          <li>
            <a
              href={page < nbPages - 1 ? getUrl(page + 1) : undefined}
              onClick={e => {
                e.preventDefault()
                onSelectPage(page + 1)
                return false
              }}
              className="pagination-link"
              disabled={page >= nbPages - 1}
            >
              {'>'}
            </a>
          </li>
        </ul>
      </nav>
      <span>
        {totalCount > perPage
          ? `${perPage} ${translate('pagination.severalPage')} ${totalCount}`
          : `${totalCount} ${
              totalCount === 1
                ? translate('pagination.singularPage.singular')
                : translate('pagination.singularPage.plural')
            }`}
      </span>
    </div>
  )
}

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  getUrl: PropTypes.func.isRequired,
  onSelectPage: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

module.exports = withTranslator(Pagination)
